// @flow
import { connect } from "react-redux";

import { createSelector } from "reselect";

import ModularUIRequest from "../../modularui/ModularUIRequest";

import { startProgress, finishProgress } from "../actions/ProgressIndicator";

import { handleError } from "../actions/Error";

import { getLocale } from "../selectors/i18n";

import { reloadModel } from "./ModularUIActions";

import type {
  ReduxState,
  StartProgressAction,
  FinishProgressAction,
  ThunkAction,
} from "../types";
import type Href from "../../models/href/Href";
import type { ModularUIModel } from "../../models/types";
import type FetchException from "../../exceptions/FetchException";
import type { ComponentType } from "react";
import type { RequestModularUIOptions } from "../../utils/fetch/types";

type StateProps = {
  modularui: (href: Href, options: any) => ModularUIRequest,
  locale: string,
};

type DispatchProps = {
  startProgress: () => StartProgressAction,
  finishProgress: () => FinishProgressAction,
  reloadModel: (
    model: ModularUIModel,
    options?: RequestModularUIOptions,
  ) => ThunkAction<>,
  handleError: (error: Error | FetchException) => ThunkAction<>,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
};

const modularui = createSelector(
  [getLocale],
  (localeCode) =>
    (href, options = {}) => {
      const modularuiRequest = new ModularUIRequest(href, options);
      modularuiRequest.locale = localeCode;
      return modularuiRequest;
    },
);

/**
 */
const mapStateToProps = (state: ReduxState): StateProps => ({
  modularui: modularui(state),
  locale: state.i18n.locale,
});

const mapDispatchToProps: DispatchProps = {
  startProgress,
  finishProgress,
  reloadModel,
  handleError,
};

/**
 * Injects the modular ui service and the progress start and finish actions
 * This can be used to request modular ui services inside react view components
 */
const withModularui: ComponentType<any> = connect<
  Props,
  {},
  StateProps,
  _,
  _,
  _,
>(mapStateToProps, mapDispatchToProps);

export default withModularui;
